"use strict";
/*
 * Thunderstorm is a full web app framework!
 *
 * Typescript & Express backend infrastructure that natively runs on firebase function
 * Typescript & React frontend infrastructure
 *
 * Copyright (C) 2020 Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiDef_ForceUpgrade = exports.ApiDef_AssertAppVersion = exports.HeaderKey_UserAgent = exports.HeaderKey_BrowserType = exports.HeaderKey_AppVersion = void 0;
const types_1 = require("./types");
exports.HeaderKey_AppVersion = 'x-app-version';
exports.HeaderKey_BrowserType = 'x-browser-type';
exports.HeaderKey_UserAgent = 'user-agent';
exports.ApiDef_AssertAppVersion = {
    method: types_1.HttpMethod.GET,
    path: 'assert-app-version',
};
exports.ApiDef_ForceUpgrade = {
    v1: {
        assertAppVersion: { method: types_1.HttpMethod.GET, path: 'assert-app-version' }
    }
};
